module.exports = __webpack_public_path__ + "assets/images/7d02d3c7848d21a046846566c28911ab.svg";